import { render, staticRenderFns } from "./BetViewList.vue?vue&type=template&id=26c72115&scoped=true"
import script from "./BetViewList.vue?vue&type=script&lang=js"
export * from "./BetViewList.vue?vue&type=script&lang=js"
import style0 from "./BetViewList.vue?vue&type=style&index=0&id=26c72115&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c72115",
  null
  
)

export default component.exports